const $ = window.jQuery;


const ToggleSections = {

    init() {

        var $module = $('.button-toggle__container');
        if (!$module.length)
            return;

        
            $module.on('click', '.section-toggle_btn', function() {
                const $document = $(document);
                const toggleFor = $(this).attr('toggle-for');

                const $section = $document.find('#'+toggleFor);
                $document.find('.section-toggle_btn.active').removeClass('active');
                if(!$section.hasClass('active-section')) {
                    $document.find('.active-section').hide('fast');
                
                }
                
                $section.show('fast');
                $section.addClass('.active-section');
                $(this).addClass('active');
            });
        

    },


};

export default ToggleSections;